// Plate calculator. Greedy from heaviest plate; warns if remainder.

const STANDARD_PLATES_KG = [20, 15, 10, 5, 2.5, 1.25] as const;

export type Plate = { kg: number; count: number };

export type PlateResult = {
  total_kg: number;
  bar_kg: number;
  side_kg: number;       // weight on each side
  plates: Plate[];       // plates per side, heavy → light
  remainder_kg: number;  // weight not coverable (warn if > 0)
};

export function calculatePlates(targetKg: number, barKg: number): PlateResult | null {
  if (!Number.isFinite(targetKg) || !Number.isFinite(barKg)) return null;
  if (targetKg < barKg) return null;
  const perSide = (targetKg - barKg) / 2;
  const plates: Plate[] = [];
  let remaining = perSide;
  for (const kg of STANDARD_PLATES_KG) {
    if (remaining < kg - 1e-6) continue;
    const count = Math.floor(remaining / kg + 1e-6);
    if (count > 0) {
      plates.push({ kg, count });
      remaining = +(remaining - count * kg).toFixed(3);
    }
  }
  return {
    total_kg: targetKg,
    bar_kg: barKg,
    side_kg: perSide,
    plates,
    remainder_kg: remaining,
  };
}

export function summarize(result: PlateResult): string {
  if (result.plates.length === 0) return 'Só a barra';
  const parts = result.plates.map((p) => `${p.count}×${p.kg}`);
  return parts.join(' + ');
}
